export default "__VITE_ASSET__6ba042af__"